<template>
  <div class="popupSelect">
    <van-popup
      v-model="show"
      round
      :close-on-click-overlay="false"
      :closeable="true"
      position="bottom"
      @closed="$emit('closePopup')"
    >
      <div class="contet">
        <h5>选择{{ title }}</h5>
        <van-search v-model="value" autofocus="true" :placeholder="`请输入${title}名称`" @input="search" />
        <ul class="listBox" v-if="value && list.length">
          <li
            v-for="item in list"
            :key="item.id"
            @click="$emit('selectInfo', item.name), (show = false)"
          >
            {{ item.name }}
          </li>
        </ul>
        <div class="empty" v-else>
          <img src="@/assets/img/arkHome/empty.png" alt="" />
          <p>暂无数据~</p>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { getSchoolApi, getSubjectApi, getTargetSchoolApi } from '@/api/archives';

export default {
  data() {
    return {
      show: true,
      value: '',
      list: [],
      timer: null,
    };
  },
  props: {
    type: {
      // 1 本科学校 3 目标学校 2 专业
      type: Number,
      default: 1,
    },
  },
  computed: {
    title() {
      return this.type === 2 ? '专业' : '学校';
    },
  },
  methods: {
    search() {
      clearTimeout(this.timer); // 防抖
      this.timer = setTimeout(() => {
        if (!this.value) {
          this.list = [];
          return;
        }
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0,
          getContainer: '.popupSelect',
        });
        if (this.type === 1) {
          this.getSchool();
        } else if (this.type === 2) {
          this.getSubject();
        } else {
          this.getTargetSchool();
        }
      }, 500);
    },

    async getSchool() {
      const { data } = await getSchoolApi(this.value);
      this.$toast.clear();
      this.list = data.data ?? [];
    },
    async getTargetSchool() {
      const { data } = await getTargetSchoolApi(this.value);
      this.$toast.clear();
      this.list = data.data ?? [];
    },
    async getSubject() {
      const { data } = await getSubjectApi(this.value);
      this.$toast.clear();
      this.list = data.data ?? [];
    },
  },
};
</script>
<style lang="scss" scoped>
.contet {
  width: 100%;
  height: 100%;
  padding: 36px;
  font-size: 25px;
  h5 {
    margin-bottom: 36px;
    font-size: 33px;
    text-align: center;
  }
  .listBox {
    width: 100%;
    height: 80%;
    overflow-y: scroll;
    li {
      color: #333;
      line-height: 80px;
    }
  }
  .empty {
    width: 290px;
    margin: 100px auto 0;
    p {
      color: #999;
      font-size: 22px;
      text-align: center;
    }
  }
}
::v-deep .van-overlay,
::v-deep .van-popup--bottom {
  z-index: 10001 !important;
}
::v-deep .van-popup--bottom {
  height: 80%;
}
::v-deep .van-search__content {
  border-radius: 100px;
}
::v-deep .van-toast--loading {
  z-index: 100002 !important;
}
::v-deep .van-popup__close-icon {
  color: #333;
}
</style>
